'use strict';

var cov_2metp44vqg = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.tags.factory.js',
        hash = '73eb6af96ed705fa24492aa5672a1c2d39432796',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.tags.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 31,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 30,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2metp44vqg.s[0]++;
(function () {
    'use strict';

    cov_2metp44vqg.f[0]++;
    cov_2metp44vqg.s[1]++;
    angular.module('app').factory('TagsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2metp44vqg.f[1]++;
        cov_2metp44vqg.s[2]++;

        return restmod.model('/tags').mix('MixinContainable', {
            $config: {
                contains: {
                    comments: {
                        type: 'hasMany',
                        table: 'CommentsTable',
                        foreignKey: 'object_id',
                        filters: {
                            /* eslint-disable camelcase */
                            object_type: 'INDUSTRY'
                        }
                    },
                    files: {
                        type: 'hasMany',
                        table: 'IndustryFilesTable',
                        foreignKey: 'industry'
                    }
                }
            }
        });
    }
})();